/**
 * NOYKA Locale Engine — Persistence
 *
 * Writes the chosen locale to cookie + localStorage + URL query param.
 */

import {
  LOCALE_STORAGE_KEY,
  LOCALE_COOKIE_KEY,
  LOCALE_QUERY_PARAM,
} from './constants';

/** Set a cookie with 1-year expiry */
function setCookie(name: string, value: string): void {
  if (typeof document === 'undefined') return;
  const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value};expires=${expires};path=/;SameSite=Lax`;
}

/** Write locale to localStorage */
function setStorage(value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, value);
    // Keep legacy key in sync
    window.localStorage.setItem('i18nextLng', value);
  } catch {
    // quota or private-mode — silently ignore
  }
}

/** Update URL query param without page reload */
export function syncUrlLocale(locale: string): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  url.searchParams.set(LOCALE_QUERY_PARAM, locale);
  window.history.replaceState(null, '', url.toString());
}

/**
 * Persist locale choice across all storage layers.
 * Call this whenever the user manually changes the language.
 */
export function persistLocale(locale: string): void {
  setCookie(LOCALE_COOKIE_KEY, locale);
  setStorage(locale);
  syncUrlLocale(locale);
}
